if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        variantStates: {},
        colorRevision: 0,
        mobileMode: window.matchMedia('(max-width: 767px)').matches,
        mobileVisible: false,
        mobileColorClass: '',
        mobileBlocksSwapped: false,
        mobileDeliveryMarker: null,
        init() {
          if (!is_combined) {
            this.variants = xParseJSON(this.$el.getAttribute('x-variants-data'));
            this.variantStates = xParseJSON(this.$el.getAttribute('data-ablyea-variant-states') || '{}');
            this.options = Array.from(this.$el.querySelectorAll('[data-ablyea-sticky-option] select')).map(select => select.value);
          }

          this._variantUpdate = (e) => {
            if (is_combined) {
              this.renderVariant(e.detail.html);
            } else {
              this.currentAvailableOptions = e.detail.currentAvailableOptions,
              this.options = e.detail.options;
            }

            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
            this.colorRevision++;
            this._refreshMobile?.();
          };
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, this._variantUpdate);
          this.initMobileVisibility();
        },
        initMobileVisibility() {
          const root = this.$el;
          const media = window.matchMedia('(max-width: 767px)');
          const styles = new Map();
          let frame = 0;
          let destroyed = false;
          const refresh = () => {
            frame = 0;
            if (destroyed || !root.isConnected) return;
            this.mobileMode = media.matches && !!root.closest('.main-product');
            this.syncMobileProductBlocks(this.mobileMode);
            if (!this.mobileMode) {
              this.mobileVisible = false;
              this.mobileColorClass = '';
              styles.forEach((original, button) => {
                button.classList.toggle('button-solid', original.solid);
                button.classList.toggle('button-outline', original.outline);
              });
              return;
            }
            const main = document.getElementById('x-atc-button-' + sectionId);
            if (!main || !main.getClientRects().length || getComputedStyle(main).visibility === 'hidden') {
              this.mobileVisible = false;
              return;
            }
            const colorOwner = main.closest('.button-product');
            this.mobileColorClass = colorOwner
              ? Array.from(colorOwner.classList).filter(name => name.startsWith('button-product-')).join(' ')
              : '';
            root.querySelectorAll('button.add_to_cart_button').forEach(button => {
              if (!styles.has(button)) styles.set(button, {
                solid: button.classList.contains('button-solid'),
                outline: button.classList.contains('button-outline')
              });
              const solid = main.classList.contains('button-solid');
              const outline = main.classList.contains('button-outline');
              if (button.classList.contains('button-solid') !== solid) button.classList.toggle('button-solid', solid);
              if (button.classList.contains('button-outline') !== outline) button.classList.toggle('button-outline', outline);
            });
            const viewport = window.visualViewport;
            const viewTop = viewport ? viewport.offsetTop : 0;
            const viewBottom = viewTop + (viewport ? viewport.height : window.innerHeight);
            const header = document.getElementById('shopify-section-header');
            const headerRect = header?.getBoundingClientRect();
            const headerStyle = header ? getComputedStyle(header) : null;
            const topEdge = headerRect && ['fixed', 'sticky'].includes(headerStyle.position) && headerRect.top <= viewTop
              ? Math.max(viewTop, headerRect.bottom) : viewTop;
            const rect = main.getBoundingClientRect();
            // Main button below viewport: show immediately. In viewport: hand over.
            // Main button scrolled above viewport: show the dock again.
            const mainVisible = rect.bottom > topEdge + 4 && rect.top < viewBottom - 4;
            this.mobileVisible = !mainVisible;
          };
          const schedule = () => {
            if (!destroyed && !frame) frame = requestAnimationFrame(refresh);
          };
          this._refreshMobile = schedule;
          window.addEventListener('scroll', schedule, { passive: true });
          window.addEventListener('resize', schedule, { passive: true });
          window.visualViewport?.addEventListener('resize', schedule, { passive: true });
          window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
          media.addEventListener('change', schedule);
          const section = document.getElementById('ProductInfo-' + sectionId) || root.closest('.main-product');
          const mutations = new MutationObserver(records => {
            if (records.some(record => !root.contains(record.target))) schedule();
          });
          if (section) mutations.observe(section, { childList: true, subtree: true, attributes: true, characterData: true });
          const resize = new ResizeObserver(schedule);
          if (section) resize.observe(section);
          const mainSection = root.closest('.main-product');
          if (mainSection && mainSection !== section) resize.observe(mainSection);
          const main = document.getElementById('x-atc-button-' + sectionId);
          if (main) resize.observe(main);
          this._cleanupMobile = () => {
            destroyed = true;
            cancelAnimationFrame(frame);
            window.removeEventListener('scroll', schedule);
            window.removeEventListener('resize', schedule);
            window.visualViewport?.removeEventListener('resize', schedule);
            window.visualViewport?.removeEventListener('scroll', schedule);
            media.removeEventListener('change', schedule);
            mutations.disconnect();
            resize.disconnect();
            styles.clear();
          };
          refresh();
          this.$nextTick(schedule);
        },
        syncMobileProductBlocks(isMobile) {
          const section = document.getElementById('ProductInfo-' + sectionId);
          const buyButtons = section?.querySelector('.x-block-buy-buttons');
          const delivery = section?.querySelector('.x-block-estimate-delivery');
          if (!buyButtons || !delivery || buyButtons.parentElement !== delivery.parentElement) return;

          if (isMobile && !this.mobileBlocksSwapped) {
            this.mobileDeliveryMarker = document.createComment('ablyea-delivery-original-position');
            delivery.before(this.mobileDeliveryMarker);
            buyButtons.before(delivery);
            this.mobileBlocksSwapped = true;
          } else if (!isMobile && this.mobileBlocksSwapped) {
            if (this.mobileDeliveryMarker?.isConnected) {
              this.mobileDeliveryMarker.replaceWith(delivery);
            }
            this.mobileDeliveryMarker = null;
            this.mobileBlocksSwapped = false;
          }
        },
        destroy() {
          this.syncMobileProductBlocks(false);
          this._cleanupMobile?.();
          document.removeEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, this._variantUpdate);
        },
        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        stickyOptionLabel(optionIndex, optionValue, displayValue) {
          if (is_combined || !Array.isArray(this.variants)) return displayValue;
          const candidateOptions = [...this.options];
          candidateOptions[Number(optionIndex)] = optionValue;
          const variant = this.variants.find(item => item.options.every((value, index) => {
            return candidateOptions[index] === String(value).replaceAll('\\/', '/');
          }));
          if (!variant) return `${displayValue} - Sold out`;
          const state = this.variantStates[String(variant.id)] || {};
          if (state.preorder) return `${displayValue} - Preorder`;
          if (state.sold_out || variant.available === false) return `${displayValue} - Sold out`;
          return displayValue;
        },
        stickyColorSelected(button) {
          this.colorRevision;
          const index = Number(button.dataset.stickyColorIndex);
          const select = button.closest('[data-ablyea-sticky-color-option]')?.querySelector('select');
          const value = !is_combined && this.options[index] !== undefined ? this.options[index] : select?.value;
          return value === button.dataset.stickyColorValue;
        },
        stickyColorDisabled(button) {
          this.colorRevision;
          this.options;
          const select = button.closest('[data-ablyea-sticky-color-option]')?.querySelector('select');
          const option = Array.from(select?.options || []).find(item => item.value === button.dataset.stickyColorValue);
          return !select || !option || select.disabled || option.disabled;
        },
        selectStickyColor(button) {
          if (this.stickyColorDisabled(button)) return;
          const select = button.closest('[data-ablyea-sticky-color-option]').querySelector('select');
          if (select.value === button.dataset.stickyColorValue) return;
          select.value = button.dataset.stickyColorValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          this.colorRevision++;
        },
        changeOptionSticky(event) {
          Array.from(event.target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          event.target.selectedOptions[0].setAttribute('selected', 'selected');
          const input = event.target.selectedOptions[0];
          const inputId = input.id;
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              inputId: inputId,
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        }
      }))
    })
  })
}
